// Funzione da eseguire quando l'elemento .ks-chart-container viene rilevato
function onKsChartContainerDetected() {
  console.log('Elemento .ks-chart-container rilevato dentro #size-kiwi-chart!');

  // Mostra il div #size-kiwi-chart-desc
  const descElement = document.getElementById('size-kiwi-chart-desc');
  if (descElement) {
    descElement.style.display = 'flex';
    descElement.addEventListener('click',(e) => {
      const closeModalButton = document.getElementById('modal-size-close');
      const sizeKiwiChart = document.querySelector('.ks-chart-modal-link');
      
      closeModalButton.click();
      sizeKiwiChart.click();
    });
    // Oppure puoi usare:
    // descElement.classList.remove('hidden');
    // descElement.classList.add('visible');
  }
  
}




// Funzione principale per il controllo
function watchForKsChartContainer() {
  const sizeKiwiChart = document.getElementById('size-kiwi-chart');
  
  // Se il contenitore #size-kiwi-chart non esiste, non possiamo fare nulla
  if (!sizeKiwiChart) {
    console.log('Contenitore #size-kiwi-chart non trovato');
    return;
  }
  
  // Controlla se l'elemento .ks-chart-container esiste già al caricamento
  if (sizeKiwiChart.querySelector('.ks-chart-container')) {
    onKsChartContainerDetected();
    return; // Interrompe il controllo se l'elemento esiste già
  }
  
  // Crea un observer per monitorare le mutazioni del contenitore #size-kiwi-chart
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Controlla se sono stati aggiunti nuovi nodi
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          // Se il nodo è un elemento e ha la classe cercata
          if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('ks-chart-container')) {
            onKsChartContainerDetected();
            observer.disconnect(); // Interrompe l'observer
            return;
          }
          
          // Se il nodo è un elemento, controlla anche i suoi figli
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.querySelector('.ks-chart-container')) {
              onKsChartContainerDetected();
              observer.disconnect(); // Interrompe l'observer
              return;
            }
          }
        });
      }
    });
  });
  
  // Configura l'observer per monitorare solo il contenitore #size-kiwi-chart
  observer.observe(sizeKiwiChart, {
    childList: true,      // Monitora aggiunta/rimozione di nodi figli
    subtree: true         // Monitora anche i nodi discendenti
  });
  
  // Timeout di sicurezza per interrompere il controllo dopo un certo tempo
  // (opzionale, rimuovi se non serve)
  setTimeout(function() {
    observer.disconnect();
    console.log('Timeout raggiunto, controllo interrotto');
  }, 30000); // 30 secondi
}

// Avvia il controllo quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchForKsChartContainer);
} else {
  watchForKsChartContainer();
}